import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {FormErrors} from '../common';
import BookForm from './BookForm';
import {createBook} from 'api';
import {addFlashMessage} from 'actions/flash-message';
import {formatErrors} from 'actions/errors';

class BookCreation extends React.Component {
  static propTypes = {
    onSubmitSuccess: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      errors: {},
    };
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
  }

  handleFormSubmit(data) {
    const {formatErrors, addFlashMessage, onSubmitSuccess} = this.props;
    return createBook(data)
      .then(() => {
        addFlashMessage('Book has been successfully created!', 'success');
        onSubmitSuccess();
      })
      .catch((err) =>
        formatErrors(err).then((err) => {
          this.setState({
            errors: err,
          });
        }),
      );
  }

  render() {
    const {errors} = this.state;
    return (
      <div>
        <FormErrors errors={errors} />
        <BookForm.Creation onSubmit={this.handleFormSubmit} />
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  formatErrors: (...args) => dispatch(formatErrors(...args)),
  addFlashMessage: (...args) => dispatch(addFlashMessage(...args)),
});

export default connect(null, mapDispatchToProps)(BookCreation);
